import 'bootstrap/js/src/dropdown'
import 'bootstrap/js/src/collapse'

import './js/animations'
import './js/sorting'

import './scss/index.scss'
